var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-box"},[_c('div',{staticClass:"l-navbar-icon",on:{"click":_vm.closeWebApp}},[_c('i',{staticClass:"icon-arrow-back"})]),_vm._v(" "),(_vm.isPad)?_c('div',{staticClass:"l-navbar-icon",on:{"click":_vm.togglePadFullScreen}},[_c('i',{class:[
        {
          'icon-narrow': _vm.isScaleModeFull,
          'icon-enlarge': !_vm.isScaleModeFull,
        } ]})]):_vm._e()])}
var staticRenderFns = []
export { render, staticRenderFns }